/**
 * Utility to clear IndexedDB for schema migration
 * This is a temporary utility to force database recreation
 */

export async function clearIndexedDB(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!window.indexedDB) {
      reject(new Error('IndexedDB not supported'));
      return;
    }

    const deleteRequest = indexedDB.deleteDatabase('MatMonsterOfflineDB');
    
    deleteRequest.onsuccess = () => {

      resolve();
    };
    
    deleteRequest.onerror = () => {
      console.error('❌ Failed to clear IndexedDB:', deleteRequest.error);
      reject(deleteRequest.error);
    };
    
    deleteRequest.onblocked = () => {
      console.warn('⚠️ IndexedDB deletion blocked - close all tabs and try again');
      reject(new Error('Database deletion blocked'));
    };
  });
}

// Make it available globally for console use
(window as unknown as { clearIndexedDB: typeof clearIndexedDB }).clearIndexedDB = clearIndexedDB;
